import { TranslateService } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { ThemeDetailsLinkComponent } from './theme-details/components/theme-details-link.component';
import { ThemeDetailsFormComponent } from './theme-details/theme-details-form.component';
import { ThemeListComponent } from './theme-list/theme-list.component';
import {
  MAT_COLOR_FORMATS,
  NgxMatColorPickerModule,
  NGX_MAT_COLOR_FORMATS,
} from '@angular-material-components/color-picker';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { ConfirmationDialogModule } from '../confirmation-dialog/confirmation-dialog.module';
import { ThemeApprovalComponent } from './theme-details/theme-approval/theme-approval.component';
import { DatePipe } from '@angular/common';

@NgModule({
  imports: [
    ConfirmationDialogModule,
    SharedModule,
    NgxMatColorPickerModule,
  ],
  declarations: [
    ThemeDetailsFormComponent,
    ThemeDetailsLinkComponent,
    ThemeListComponent,
    ThemeApprovalComponent,
  ],
  providers: [
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    DatePipe,
  ],
  exports: [ThemeDetailsLinkComponent, ThemeListComponent],
})
export class ThemingModule {
  constructor(protected translate: TranslateService) {}
}
